(function () {
    'use strict';

    angular.module('map')
        .service('ArcGISMap', ['$rootScope', '$window', '$http', '$filter', '$timeout', 'editService', 'DataService', 'NotesService', 'mapConfigService',
            'GalleryService', 'DocumentService', 'userService', 'dialogService', 'FilterService',
            function ($rootScope, $window, $http, $filter, $timeout, editService, DataService, NotesService, mapConfigService,
                GalleryService, DocumentService, userService, dialogService, FilterService) {

                var loaded = false;
                var map;
                var securityObjLayer, objectRoadLayer, myLocationLayer, roadMeasurementLayer;
                var dataService = DataService;
                var ctxMenuForMap;
                var searchString;

                var timeoutPromise = {};
                $rootScope.$on('newSearchString', function($event, newSearchString) {
                    searchString = newSearchString;
                    $timeout.cancel(timeoutPromise);
                    timeoutPromise = $timeout(function(){addLayerPoints();}, 400);
                });

                $rootScope.$broadcast('searchStringRequest');

                function search(element) {
                    return DataService.filterData(element, searchString);
                }

                function createMapMenu() {
                    var mapPoint;
                    ctxMenuForMap = new dijit.Menu({
                        onOpen: function (box) {
                            var x = box.x, y = box.y;
                            switch (box.corner) {
                                case 'TR':
                                    x += box.w;
                                    break;
                                case 'BL':
                                    y += box.h;
                                    break;
                                case 'BR':
                                    x += box.w;
                                    y += box.h;
                                    break;
                            }

                            var screenPoint = new esri.geometry.Point(x - map.position.x, y - map.position.y);
                            mapPoint = map.toMap(screenPoint);
                        }
                    });
                    ctxMenuForMap.addChild(new dijit.MenuItem({
                        label: '<button class="btn btn-primary btn-sm info-widget-button" style="width: 100%;"><strong>Naujas</strong></button>',
                        onClick: function () {
                            if (!userService.getPermissions().edit && !userService.getPermissions().editAll) {
                                dialogService.error('', 'Nepakanka teisių');
                                return;
                            }
                            var coords = {
                                geometries: [
                                    {
                                        x: Number(mapPoint.x.toFixed(2)),
                                        y: Number(mapPoint.y.toFixed(2))
                                    }
                                ]
                            };
                            $rootScope.$broadcast('openLocationDialog', coords);
                        }
                    }));
                    ctxMenuForMap.addChild(new dijit.MenuItem({
                        label: '<button class="btn btn-primary btn-sm info-widget-button" style="width: 100%;"><strong>Kelio matavimai</strong></button>',
                        onClick: function () {
                            $rootScope.$broadcast('toggleMeasurements', mapPoint);
                        }
                    }));
                    ctxMenuForMap.startup();
                    ctxMenuForMap.bindDomNode(map.container);
                }

                //angular doesn't parse map info window so we use global variable to pass callback function
                mapCallbacks.editItem = function (itemId) {
                    angular.forEach(dataService.getData(), function (data) {
                        if (itemId == data.id) {
                            editService.obj = data;
                        }
                    });
                    if (editService.obj) {
                         var data = angular.copy(editService.obj);
                            editService.updateStatus(data).then(function(response){
                            DataService.refreshData(FilterService.filters);
                            editService.obj = response.data;
                            $rootScope.Ui.turnOn('edit');
                    });
                    }
                };
                mapCallbacks.showNotes = function (itemId) {
                    NotesService.obj = null;
                    angular.forEach(dataService.getData(), function (data) {
                        if (itemId == data.id) {
                            NotesService.resetNotes();
                            NotesService.obj = angular.copy(data);
                            NotesService.loadNotes();
                        }
                    });
                    if (NotesService.obj) {
                        $rootScope.Ui.turnOn('notes');
                        $rootScope.$apply();
                    }
                };
                mapCallbacks.openStreetView = function (x, y) {
                    if (isNaN(x) || isNaN(y)) {
                        alert('Please enter valid numbers');
                    } else {
                        var inSR = new esri.SpatialReference({
                            wkid: 3346
                        });
                        var outSR = new esri.SpatialReference({
                            wkid: 4258
                        });
                        var geometryService = new esri.tasks.GeometryService(mapConfigService.geometryServiceURL);
                        var inputpoint = new esri.geometry.Point(x, y, inSR);
                        var PrjParams = new esri.tasks.ProjectParameters();
                        PrjParams.geometries = [inputpoint];
                        PrjParams.outSR = outSR;
                        geometryService.project(PrjParams, function (outputpoint) {
                            $window.open(mapConfigService.googleStreetViewURL + outputpoint[0].y + ',' + outputpoint[0].x + '&layer=c', '_blank');
                        });
                    }
                };

                mapCallbacks.openGallery = function (id) {
                    var items = dataService.getData().filter(function (obj) {
                        return obj.id === id;
                    });
                    if (items.length === 0) {
                        return;
                    }
                    GalleryService.setCurrentObject(items[0]);
                    $rootScope.Ui.turnOn('gallery');
                    $rootScope.$apply();
                };

                mapCallbacks.openDocuments = function (id) {
                    var items = dataService.getData().filter(function (obj) {
                        return obj.id === id;
                    });
                    if (items.length === 0) {
                        return;
                    }
                    DocumentService.setCurrentObject(items[0]);
                    $rootScope.$emit('openDocuments');
                    $rootScope.Ui.turnOn('documents');
                    $rootScope.$apply();
                };

                function showInfoWindow(evt) {
                    objectRoadLayer.clear();
                    var kpo = evt.graphic.attributes;
                    var content =
                        '<table class="info-widget-table">' +
                        '   <tr>' +
                        '       <td><strong>Kelias: </strong></td>' +
                        '       <td>' + kpo.kelioNumeris + ' ' + kpo.kelioPavadinimas + '</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <td><strong>Nuo: </strong></td>' +
                        '       <td>' + kpo.kmNuo + ' km </td>' +
                        '   </tr>' +
                        ( kpo.kmIki ?
                        '   <tr>' +
                        '       <td><strong>Iki: </strong></td>' +
                        '       <td>' + kpo.kmIki + ' km </td>' +
                        '   </tr>' : '' ) +
                        ( kpo.padaliniuPavadinimai ?
                            '   <tr>' +
                            '       <td><strong>Regionas: </strong></td>' +
                            '       <td>' + kpo.padaliniuPavadinimai + '</td>' +
                            '   </tr>' : '' ) +
                        (kpo.defektuGrupiuPavadinimai === '' ? '' :
                            '   <tr>' +
                            '       <td><strong>Defektų grupės: </strong></td>' +
                            '       <td>' + kpo.defektuGrupiuPavadinimai + '</td>' +
                            '   </tr>') +
                        ( kpo.aprasymas ?
                            '   <tr>' +
                            '       <td><strong>Aprašymas: </strong></td>' +
                            '       <td>' + kpo.aprasymas.substring(0, 60) + '</td>' +
                            '   </tr>' : '' ) +
                        ( kpo.apziurosData ?
                            '   <tr>' +
                            '       <td><strong>Apžiūros data: </strong></td>' +
                            '       <td>' + $filter('date')(kpo.apziurosData, 'yyyy-MM-dd') + '</td>' +
                            '   </tr>' : '' ) +
                        ( kpo.sprendimoData ?
                            '   <tr>' +
                            '       <td><strong>Išsprendimo data: </strong></td>' +
                            '       <td>' + $filter('date')(kpo.sprendimoData, 'yyyy-MM-dd') + '</td>' +
                            '   </tr>' : '' ) +
                        ( kpo.sukuresNaudotojas ?
                            '   <tr>' +
                            '       <td><strong>Sukūrė: </strong></td>' +
                            '       <td>' + kpo.sukuresNaudotojas + '</td>' +
                            '   </tr>' : '' ) +
                        '</table>' +
                        '</br>' +
                        '<div class="kpo-info-dialog-buttons">' +
                        '   <div class="btn-group">' +
                        '      <button title="Redagavimas" class="edit-btn btn btn-primary btn-sm info-widget-button"><i class="fa fa-info"></i></button> ' +
                        '      <button title="Street View" class="street-view-btn btn btn-primary btn-sm info-widget-button"><i class="fa fa-street-view"></i></button> ' +
                        (kpo.pastabuKiekis ?
                        '      <button title="Pastabos" class="note-btn btn btn-primary btn-sm info-widget-button"><i class="fa fa-comment-o"></i></button> ' :
                        '      <button title="Pastabos" class="note-btn btn btn-primary btn-sm info-widget-button btn-no-records"><i class="fa fa-comment-o"></i></button> ' ) +
                        (kpo.nuotraukuKiekis ?
                        '      <button title="Galerija" class="gallery-btn btn btn-primary btn-sm info-widget-button"><i class="fa fa-image"></i></button> ' :
                        '      <button title="Galerija" class="gallery-btn btn btn-primary btn-sm info-widget-button btn-no-records"><i class="fa fa-image"></i></button> ' ) +
                        (kpo.dokumentuKiekis ?
                        '       <button title="Dokumentai" class="doc-btn btn btn-primary btn-sm info-widget-button"><i class="fa fa-file-text-o"></i></button> ' :
                        '       <button title="Dokumentai" class="doc-btn btn btn-primary btn-sm info-widget-button btn-no-records"><i class="fa fa-file-text-o"></i></button> ' ) +
                        '   </div>' +
                        '</div>';
                    var contentDom = document.createElement('div');
                    contentDom.innerHTML = content;
                    contentDom.querySelector('.edit-btn').addEventListener('click', function() { mapCallbacks.editItem(kpo.id); });
                    contentDom.querySelector('.street-view-btn').addEventListener('click', function() { mapCallbacks.openStreetView(kpo.xnuo, kpo.ynuo); });
                    contentDom.querySelector('.note-btn').addEventListener('click', function() { mapCallbacks.showNotes(kpo.id); });
                    contentDom.querySelector('.gallery-btn').addEventListener('click', function() { mapCallbacks.openGallery(kpo.id); });
                    contentDom.querySelector('.doc-btn').addEventListener('click', function() { mapCallbacks.openDocuments(kpo.id); });

                    map.infoWindow.setTitle('Kelių priežiūros objektas');
                    map.infoWindow.setContent(contentDom);
                    map.infoWindow.resize(350, 'auto');
                    map.infoWindow.show(evt.mapPoint);
                    createPath(kpo, objectRoadLayer);
                }

                function createPath(kpo, layer) {
                    if (!kpo.id || !kpo.kmIki || kpo.kmNuo === kpo.kmIki || !kpo.linijinisObjektas) {//check for geometry data
                        return;
                    }

                    $http.get(mapConfigService.kpoGeometryURL, {params:{id: kpo.id}}).success(function (data) {
                        var line = new esri.geometry.Polyline(new esri.SpatialReference({ wkid: 3346 }));

                        for (var i = 0; i < data.length; i++) {
                            var points = [];

                            for (var j = 0; j < data[i].length; j++) {
                                points.push(
                                    new esri.geometry.Point(data[i][j].x, data[i][j].y, new esri.SpatialReference({ wkid: 3346 }))
                                );
                            }

                            line.addPath(points);
                        }

                        line.addPath(points);
                        var lSymbol = new esri.symbol.SimpleLineSymbol(
                            esri.symbol.SimpleLineSymbol.STYLE_SOLID,
                            new esri.Color([0x00, 0x7A, 0xFF, 0.5]), 3
                        );
                        var lineGraphics = new esri.Graphic(line, lSymbol);
                        layer.add(lineGraphics);
                    })

                }

                function addLayerPoints() {
                        if (!map) {
                            return;
                        }
                        if (!objectRoadLayer) {
                            objectRoadLayer = new esri.layers.GraphicsLayer({
                                id: 'Objekto kelias',
                                visible: true
                            });
                            map.addLayer(objectRoadLayer);
                            window.objectRoadLayer = objectRoadLayer;
                        }
                        if (!securityObjLayer) {
                            securityObjLayer = new esri.layers.GraphicsLayer({
                                id: 'Kelių priežiūros objektai',
                                visible: true
                            });
                            securityObjLayer.on('click', showInfoWindow);
                            map.infoWindow.on('hide', function () {
                                objectRoadLayer.clear();
                            });
                            map.addLayer(securityObjLayer);
                        }

                        objectRoadLayer.clear();
                        securityObjLayer.clear();
                        angular.forEach($filter('filter')(dataService.getData(), search), function (data) {
                            if (data.xnuo && data.ynuo) {
                                var x, y;
                                if (data.ynuo < data.xnuo) {
                                    x = data.ynuo;
                                    y = data.xnuo;
                                } else {
                                    y = data.ynuo;
                                    x = data.xnuo;
                                }
                                var point = new esri.geometry.Point(x, y, new esri.SpatialReference({ wkid: 3346 }));
                                var marker = new esri.Graphic({ 'geometry': point, 'attributes': data });
                                var infoSymbol = new esri.symbol.SimpleMarkerSymbol();
                                if (data.darbuRusis === 'PP') {
                                    infoSymbol.setSize(15, 15);
                                    infoSymbol.setStyle('diamond');
                                }  else if (data.darbuRusis === 'KD') {
                                    infoSymbol.setSize(12, 12);
                                    infoSymbol.setStyle('square');
                                } else if (data.darbuRusis === 'LP') {
                                    infoSymbol.setPath('M 0,0 V 30 H 15 V 25 H 5 V 0 Z');
                                    infoSymbol.setSize(18, 5);
                                    infoSymbol.setOffset(0, 12);
                                } else if (data.darbuRusis === 'IL') {
                                    infoSymbol.setPath('M 8,12 a 6,6 0 1 0 -0.001,0 z m 0,2 h -8 v 6 h 3 v 16 h -3 v 6 h 16 v -6 h -3 v -16 h 3 v -6 z');
                                    infoSymbol.setSize(16, 4);
                                    infoSymbol.setOffset(0, 10);
                                } else {
                                    infoSymbol.setPath('m-5,0q0,2.12891 0.64453,3.49609l7.10938,15.11719q0.3125,0.64453 0.92773,1.01563q0.61523,0.37109 1.31836,0.37109q0.70313,0 1.31836,-0.37109q0.61523,-0.37109 0.9082,-1.01563l7.12891,-15.11719q0.64453,-1.36719 0.64453,-3.49609q0,-4.14063 -2.92969,-7.07031q-2.92969,-2.92969 -7.07031,-2.92969q-4.14063,0 -7.07031,2.92969q-2.92969,2.92969 -2.92969,7.07031z');
                                    infoSymbol.setOffset(0, 12);
                                    infoSymbol.setSize(22, 5);
                                }
                                infoSymbol.setOutline(new esri.symbol.SimpleLineSymbol().setWidth(1));
                                if (data.pazeidimai && data.pazeidimai.length > 0) {
                                    var time = 'N';
                                    if (data.defektoStatusasLowValue === 'DSPR') {
                                        time = 'S';
                                    } else {
                                        if (data.sprendimoData !== null) {
                                            var now = new Date();
                                            var sprendimoData = new Date(data.sprendimoData)
                                            if (now > sprendimoData) {
                                                time = 'V';
                                            } else if ((now.getTime() + 604800000) > sprendimoData) {
                                                time = 'A';
                                            }
                                        }
                                    }
                                    infoSymbol.setColor(new esri.Color(mapConfigService.mapIconConfig[data.defektoStatusasLowValue][time]));
                                } else {
                                    infoSymbol.setColor(new esri.Color([200, 200, 200]));
                                }
                                marker.setSymbol(infoSymbol);
                                securityObjLayer.add(marker);
                            }
                        });
                    }

                return {
                    set: function (element) {
                        if (!loaded) {
                            var initExtent = new esri.geometry.Extent(282154, 5913677, 688555, 6278168, new esri.SpatialReference({ wkid: 3346 }));
                            map = new esri.Map(element[0], {
                                logo: false,
                                extent: initExtent,
                                slider: false,
                                spatialReference: new esri.SpatialReference({ wkid: 3346 })
                            });

                            try {
                                var cachedLayer = new esri.layers.ArcGISTiledMapServiceLayer(
                                    mapConfigService.mapServerTiledURL, { id: 'Georeferencinis pagrindas' });
                                cachedLayer.setMaxScale(2000);
                                map.addLayer(cachedLayer);
                            } catch(err) {
                                onCachedLayerError({target: {}});
                            }
                            var cachedOrthoLayer = new esri.layers.ArcGISTiledMapServiceLayer(
                                mapConfigService.mapOrthoLayerCacheURL, { id: 'Ortofoto pagrindas', visible: false });
                            cachedOrthoLayer.setMaxScale(2000);
                            map.addLayer(cachedOrthoLayer);

                            cachedLayer.on('error', onCachedLayerError);
                            cachedOrthoLayer.on('error', onCachedLayerError);

                            map.on('load', onMapLoad);

                            function onCachedLayerError(args) {
                                if (!args.target.loaded) {
                                    map.destroy();
                                    map = new esri.Map(element[0], {
                                        extent: initExtent,
                                        logo: false,
                                        slider: false
                                    });
                                    var cachedLayer = new esri.layers.ArcGISTiledMapServiceLayer(
                                        mapConfigService.mapServerTiledFallbackURL, { id: 'Georeferencinis pagrindas' });
                                    cachedLayer.setMaxScale(2000);
                                    map.addLayer(cachedLayer);

                                    var cachedOrthoLayer = new esri.layers.ArcGISTiledMapServiceLayer(
                                        mapConfigService.mapOrthoLayerCacheFallbackURL, { id: 'Ortofoto pagrindas', visible: false});
                                    cachedOrthoLayer.setMaxScale(2000);
                                    map.addLayer(cachedOrthoLayer);

                                    map.on('load', onMapLoad);
                                }
                            }

                            function onMapLoad() {
                                addLayerPoints();
                                createMapMenu();

                                myLocationLayer = new esri.layers.GraphicsLayer({
                                    id: 'My_location',
                                    visible: true
                                });
                                map.addLayer(myLocationLayer);

                                roadMeasurementLayer = new esri.layers.GraphicsLayer({
                                    id: 'Road_measurement_layer',
                                    visible: true
                                });
                                map.addLayer(roadMeasurementLayer);

                                //Workaround. Map brokes when window is resized not in map state.
                                //Therefore we hide map when leave and show when entering map state.
                                $rootScope.$on('$routeChangeStart', function (angularEvent, next, current) {
                                    if (current.originalPath.indexOf('/map') !== -1 && next.originalPath.indexOf('/map') === -1) {
                                        map.setVisibility(false);
                                    }
                                    if (current.originalPath.indexOf('/map') === -1 && next.originalPath.indexOf('/map') !== -1) {
                                        map.setVisibility(true);
                                    }
                                });
                            }
                        }

                        loaded = true;
                        return map;
                    },
                    get: function () {
                        return map;
                    },
                    zoomToPoint: function (item) {
                        if (map) {
                            var point = new esri.geometry.Point(item.xnuo, item.ynuo, new esri.SpatialReference({ wkid: 3346 }));
                            var evt = {
                                graphic: {
                                    attributes: item
                                },
                                mapPoint: point
                            };
                            showInfoWindow(evt);
                            map.centerAndZoom(point, 8);
                        }
                    },
                    zoomToMyLocation: function (item) {
                        if (map) {
                            var point = new esri.geometry.Point(item.xnuo, item.ynuo, new esri.SpatialReference({ wkid: 3346 }));
                            var evt = {
                                graphic: {
                                    attributes: item
                                },
                                mapPoint: point
                            };
                            showInfoWindow(evt);
                            map.centerAndZoom(point, 8);
                        }
                    },
                    addLayerPoints: addLayerPoints,
                    showMyLocation: function (x, y) {
                        if (map) {
                            var point = new esri.geometry.Point(x, y, new esri.SpatialReference({ wkid: 3346 }));
                            var marker = new esri.Graphic({ 'geometry': point });
                            var infoSymbol = new esri.symbol.SimpleMarkerSymbol();
                            infoSymbol.setSize(20);
                            infoSymbol.setStyle('x');
                            infoSymbol.setOutline(new esri.symbol.SimpleLineSymbol().setWidth(5).setColor(new esri.Color([200, 0, 200])));
                            marker.setSymbol(infoSymbol);
                            myLocationLayer.add(marker);
                            map.centerAndZoom(point, 9)
                        }
                    },
                    hideMyLocation: function () {
                        if (map) {
                            myLocationLayer.clear();
                        }
                    },
                    showRoadMeasurement: function(x, y) {
                        if (map) {
                            var point = new esri.geometry.Point(x, y, new esri.SpatialReference({ wkid: 3346 }));
                            var marker = new esri.Graphic({ 'geometry': point });
                            var infoSymbol = new esri.symbol.SimpleMarkerSymbol();
                            infoSymbol.setSize(20);
                            infoSymbol.setStyle('x');
                            infoSymbol.setOutline(new esri.symbol.SimpleLineSymbol().setWidth(5).setColor(new esri.Color([200, 0, 0])));
                            marker.setSymbol(infoSymbol);
                            roadMeasurementLayer.clear();
                            roadMeasurementLayer.add(marker);
                            if (map.getZoom() < 6) {
                                map.centerAndZoom(point, 9);
                            } else {
                                map.centerAt(point);
                            }
                        }
                    },
                    hideRoadMeasurement: function() {
                        if (map) {
                            roadMeasurementLayer.clear();
                        }
                    }
                };
            }]);
})();
